<template>
    <component :is="guidanceContent" v-bind="{hiddenHeadings}"></component>
</template>

<script>
    import { PlusIcon, MinusIcon } from 'vue-feather-icons'
    import { VBtn } from 'vuetify/lib'
    import { i18n } from "../translations/i18n"

    export default {
        name: "SammioCardGuidance",
        props: {
            contentHtml: String,
            hiddenHeadings: Array,
            cardIndex: String
        },
        computed: {
            guidanceContent() {
                return {
                    props: {
                        hiddenHeadings: {
                            type: Array,
                            default: function() { return []; }
                        }
                    },
                    template: this.getComponentTemplate(this.contentHtml),
                    components: {
                        PlusIcon,
                        MinusIcon,
                        VBtn
                    },
                    methods: {
                        onHeadingClick(index) {
                            const currentIndex = this.hiddenHeadings.indexOf(index)
                            const alreadyHidden = currentIndex >= 0
                            if (alreadyHidden) {
                                this.hiddenHeadings.splice(currentIndex, 1)
                            } else {
                                this.hiddenHeadings.push(index)
                            }
                            this.$parent.$emit('update-hidden-guidance-indices', { indices: this.hiddenHeadings })
                        },
                        headingHidden(index) {
                            return this.hiddenHeadings.indexOf(index) >= 0
                        }
                    }
                }
            }
        },
        methods: {
            getComponentTemplate(html) {
                const guidanceDom = jQuery('<div>').append(jQuery.parseHTML(html))

                const cardIndex = this.cardIndex;
                let context = this
                guidanceDom.find('h3').each(function(h3Index, h3Node) {
                    let heading = jQuery(h3Node)
                    heading[0].setAttribute(':class', 'hiddenHeadings.indexOf('+ h3Index +') < 0 ? "card__title--guidance-subtitle" : "card__title--guidance-subtitle d-print-none"')
                    heading.nextUntil('h3,div').each(function(pIndex, pNode) {
                        pNode.setAttribute('v-if', 'hiddenHeadings.indexOf('+ h3Index +') < 0');
                    });

                    let col2 = jQuery('<div>').addClass('col-md-1 p-0 text-right')
                    let btn = jQuery(context.getAccordionControlTemplate(h3Index, cardIndex, h3Node))
                    btn.appendTo(col2)

                    let row = jQuery('<div>').addClass('row')
                    let col1 = jQuery('<div>').addClass('col-md-11')
                    heading.wrapAll(row)
                    heading.wrapAll(col1).parent().parent().append(col2)
                })
                return guidanceDom.prop('outerHTML')
            },
            getAccordionControlTemplate(h3Index, cardIndex, h3Node) {
                const indexData = cardIndex + '-' + h3Index;
                const headerText = jQuery(h3Node).text();
                return '' +
                    '<v-btn class="btn btn-link p-0 mb-0 mr-2" :aria-expanded="!headingHidden('+ h3Index +')" :aria-controls="\'accordion_content-' + indexData + '\'" :id="\'accordion_header-' + indexData + '\'"' +
                    '   v-on:click.prevent="onHeadingClick('+ h3Index +')">' +
                    '   <span class="text-right" v-if="headingHidden('+ h3Index +')">' +
                    '       <span class="sr-only">' + this.$t('sammio.open') + ' ' + headerText + '</span>' +
                    '       <plus-icon size="1.25x"></plus-icon>' +
                    '   </span>' +
                    '   <span class="text-right" v-else>' +
                    '       <span class="sr-only">' + this.$t('sammio.close') + ' ' + headerText + '</span>' +
                    '       <minus-icon size="1.25x"></minus-icon>' +
                    '   </span>' +
                    '</v-btn>'
            }
        }
    }
</script>

<style scoped>

</style>